import { cleanText } from '../cleanText'

export const getCleanValue = (value?: string) => {
  return cleanText(value || '')
}
